const inboxListReducers = (state = [], action) => {
  switch (action.type) {
    case "storeInboxList":
      return action.payload;
    default:
      return state;
  }
};
export default inboxListReducers;
